var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{style:(_vm.appBack)},[_c('v-content',[_c('Resume')],1),_c('v-layout',{attrs:{"justify-center":""}},[_c('Slider')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }